import { LANG_AR, LANG_EN } from "../../../../Components/Templates/WeddingTemplates/constants";
import { FilterOptions } from "../../index";
import { User } from "../../auth/dto/auth.dto";

export interface InvitationCoordinates {
	lat: number;
	lng: number;
}

export interface Invitations {
	_id: string;
	name: string;
	type: number;
	description: string;
	intro_text: string;
	accepted: number;
	pricing: Price[];
	template_original_id: Partial<Invitations>;
	selectedPricingPlan: INVITATION_PRICING_PLANS_ENUM;
	currency: string;
	discount: number;
	main_image: string;
	is_discount_percentage: boolean;
	is_published: boolean;
	thumbnail_01: string;
	thumbnail_02: string;
	template_id: number;
	groom_name: string;
	bride_name: string;
	groom_image: string;
	bride_image: string;
	wedding_date: string;
	partner_socials_1: Social[];
	partner_socials_2: Social[];
	story: IStory[];
	story_image: string;
	gallery: IGallery[];
	wedding_location_text: string;
	wedding_location: string;
	sub_intro_text: string;
	conclusion_text: string;
	save_the_date_text: string;
	gift_text: string;
	comments_text: string;
	comments_sub_text: string;
	language: string;
	is_private: boolean;
	status: INVITATION_STATUS;
	password: string | null;
	is_islamic: boolean;
	is_coming_soon: boolean;
	createdAt: string;
	user_id: User;
	fieldVisibility: IfieldVisibility;
	fieldUpdate: IfieldUpdate;
	wedding_album: boolean;
	memories_qr_code: string;
	invitation_qr_code: string;
	wedding_coordinates: InvitationCoordinates;
	has_images: boolean;
	timezone: string;
	updatedAt: string;
	template_color: number;
	occasion: number;
	responseStats?: {
		total_views: number;
		total: number;
		accepted: number;
		declined: number;
	};
	entrance: INVITATION_ENTRANCE;
}

export interface IfieldVisibility {
	gallery?: { hidden: boolean };
	loveStory?: { hidden: boolean };
	location?: { hidden: boolean };
	comments?: { hidden: boolean };
	save_the_date_text?: { hidden: boolean };
	intro_text?: { hidden: boolean };
	sub_intro_text?: { hidden: boolean };
	comments_text?: { hidden: boolean };
	comments_sub_text?: { hidden: boolean };
	conclusion_text?: { hidden: boolean };
	wedding_location_text?: { hidden: boolean };
	main_image?: { hidden: boolean };
	bride_image?: { hidden: boolean };
	groom_image?: { hidden: boolean };
	story_image?: { hidden: boolean };
}

export interface IfieldUpdate {
	bride_name: boolean;
	groom_name: boolean;
	wedding_date: boolean;
	wedding_location_text: boolean;
	wedding_coordinates: boolean;
	main_image: boolean;
	bride_image: boolean;
	groom_image: boolean;
	partner_socials_1: boolean;
	partner_socials_2: boolean;
}

export interface IAnime {
	id: number;
	main_image: string;
	groom_image: string;
	bride_image: string;
}

export interface Social {
	_id: string;
	social_type: number;
	value: string;
	hasError?: boolean;
}
export interface IGallery {
	_id: string;
	image_url: string;
	order: number;
	type?: string;
	video_url?: string;
	user_email?: string;
	is_private?: boolean;
}

export interface IStory {
	_id: string;
	title: string;
	description: string;
}

export enum INVITATION_RESPONSE_TYPE {
	COMING = 1,
	CANT_COME = 2
}
export const INVITATION_RESPONSE_MAP = {
	[INVITATION_RESPONSE_TYPE.COMING]: "Accepted",
	[INVITATION_RESPONSE_TYPE.CANT_COME]: "Declined"
};

export interface IComment {
	_id: string;
	name: string;
	email: string;
	is_email_verified: boolean;
	comment: string;
	response: INVITATION_RESPONSE_TYPE;
	invitation_id: string;
	anonymous_token: string;
	createdAt: string;
	verify_email_otp?: string;
	isApproved: boolean;
}

export enum TEMPLATES {
	TEMPLATES01 = 1,
	TEMPLATES02 = 2,
	TEMPLATES03 = 3,
	TEMPLATES04 = 4,
	TEMPLATES05 = 5,
	TEMPLATES06 = 6,
	TEMPLATES07 = 7,
	TEMPLATES08 = 8
}

export enum INVITATION_TYPES {
	TEMPLATE = 1,
	USER = 2
}

export enum INVITATION_SOCIALS {
	INSTAGRAM = 1,
	FACEBOOK = 2,
	TIKTOK = 3
}

export enum INVITATION_STATUS {
	DRAFT = 1,
	PENDING = 2,
	PUBLISHED = 3,
	REJECTED = 4,
	SUSPENDED = 5,
	DELETED = 6,
	ACTION_REQUIRED = 7
}

export enum INVITATION_OCCASION {
	WEDDING = 1,
	ENGAGEMENT = 2,
	KATB_KTAB = 3
}

export const INVITATION_STATUSES = {
	[INVITATION_STATUS.DRAFT]: "DRAFT",
	[INVITATION_STATUS.PENDING]: "PENDING",
	[INVITATION_STATUS.PUBLISHED]: "PUBLISHED",
	[INVITATION_STATUS.REJECTED]: "REJECTED",
	[INVITATION_STATUS.SUSPENDED]: "SUSPENDED",
	[INVITATION_STATUS.DELETED]: "DELETED",
	[INVITATION_STATUS.ACTION_REQUIRED]: "ACTION REQUIRED"
};

export type LangType = typeof LANG_EN | typeof LANG_AR;

export interface InvitationStats {
	total_views: number;
	total_responses: number;
	accepted_responses: number;
	rejected_responses: number;
	total_memories: number;
}

export interface IWeddingInvitationComments extends FilterOptions {
	id: string;
	password?: string;
	status?: number;
}
export interface IWeddingInvitationComment {
	id: string;
	password?: string;
	anonymous_token: string;
}

export interface Price {
	type: INVITATION_PRICING_PLANS_ENUM;
	name: string;
	amount: number;
	discount: number;
	is_discount_percentage: boolean;
	currency: string;
}
export interface IPayedInvitation extends Price {
	isPayed: boolean;
}

export interface InvitationLastPaymentTransaction {
	type: TRANSACTION_TYPE_ENUM;
	orderId: string;
	amount: number;
	discount: number;
	is_discount_percentage: boolean;
	currency: string;
}
export enum InvitationColorTheme {
	COLOR01 = 1,
	COLOR02 = 2,
	COLOR03 = 3,
	COLOR04 = 4
}

export enum INVITATION_PRICING_PLANS_ENUM {
	FREE = 0,
	ESSENTIAL,
	SIGNATURE
}

export enum INVITATION_ENTRANCE {
	NAMES = 0,
	ENVELOPE = 1,
	RINGS = 2,
	CURTAIN = 3,
	PALACE_DOORS = 4
}

export enum TRANSACTION_TYPE_ENUM {
	PAYMENT = 1,
	REFUND = 2
}
export interface PRICING_PLAN_TYPE {
	image_size: number;
	gallery_media_count: number;
	video_size: number;
	is_guest_memory_enabled: boolean;
	memory_album_count: number;
	memory_album_video_enabled: boolean;
	is_color_theme_enabled: boolean;
	description: string;
	features: string[];
}
